// Utility helpers for working with admin email preferences.
import { EMAIL_PREFERENCE_DEFAULTS, EMAIL_PREFERENCE_OPTIONS } from "./constants.js";

export const getDefaultEmailPreferences = () => ({ ...EMAIL_PREFERENCE_DEFAULTS });

export const normalizeEmailPreferences = (prefs = {}) => {
  const normalized = getDefaultEmailPreferences();

  Object.keys(normalized).forEach((key) => {
    if (typeof prefs?.[key] === "boolean") {
      normalized[key] = prefs[key];
    }
  });

  return normalized;
};

export const areEmailPreferencesEqual = (a = {}, b = {}) => {
  return Object.keys(EMAIL_PREFERENCE_DEFAULTS).every((key) => {
    const aValue = typeof a?.[key] === "boolean" ? a[key] : EMAIL_PREFERENCE_DEFAULTS[key];
    const bValue = typeof b?.[key] === "boolean" ? b[key] : EMAIL_PREFERENCE_DEFAULTS[key];
    return aValue === bValue;
  });
};

export const emailPreferencesToTopics = (preferences = {}) => {
  const normalized = normalizeEmailPreferences(preferences);
  const topics = {};

  EMAIL_PREFERENCE_OPTIONS.forEach((option) => {
    if (!option.subscriptionId) {
      return;
    }
    topics[`topic_${option.subscriptionId}`] = normalized[option.key];
  });

  return topics;
};

export const topicsToEmailPreferences = (topics = {}) => {
  const normalized = getDefaultEmailPreferences();

  EMAIL_PREFERENCE_OPTIONS.forEach((option) => {
    const topicKey = option.subscriptionId ? `topic_${option.subscriptionId}` : null;
    if (topicKey && typeof topics?.[topicKey] === "boolean") {
      normalized[option.key] = topics[topicKey];
    }
  });

  return normalized;
};

export const emailPreferencesToAttributes = (preferences = {}) => {
  const normalized = normalizeEmailPreferences(preferences);
  return Object.fromEntries(Object.entries(normalized).map(([key, value]) => [`email_pref_${key}`, value]));
};
